import request from 'utils/request'

// 获取表格数据
export const getTableData = data => request().post('public/folder/page', data)

// 新增或者修改
export const add = data => request().post('public/folder/saveOrUpdate', data)

// 删除
export const remove = id => request().get(`public/folder/delete/${id}`)

// 删除文件上传 =()=>
export const removeUploadDocument = data =>
  request().post(`public/folder/delete/file`, data)

// 下载文件public/folder/download/{id}
export const download = id =>
  request().get(`public/folder/download/${id}`, { responseType: 'blob' })
